import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { BackgroundAudio } from '../components/BackgroundAudio';
// Performance: tracking & framer-motion removed from critical bundle
// tracking is dynamically imported in useEffect and click handlers
const ClaridadSection = lazy(() => import('../components/ClaridadSection').then(m => ({
  default: m.ClaridadSection
})));
const QueEsSection = lazy(() => import('../components/QueEsSection').then(m => ({
  default: m.QueEsSection
})));
const TestimoniosSection = lazy(() => import('../components/TestimoniosSection').then(m => ({
  default: m.TestimoniosSection
})));
const MetodoSection = lazy(() => import('../components/MetodoSection').then(m => ({
  default: m.MetodoSection
})));
const MecanismoNuevoSection = lazy(() => import('../components/MecanismoNuevoSection').then(m => ({
  default: m.MecanismoNuevoSection
})));
const QueIncluyeSection = lazy(() => import('../components/QueIncluyeSection').then(m => ({
  default: m.QueIncluyeSection
})));
const NoEsParaTiSection = lazy(() => import('../components/NoEsParaTiSection').then(m => ({
  default: m.NoEsParaTiSection
})));
const ComparacionPlanesSection = lazy(() => import('../components/ComparacionPlanesSection').then(m => ({
  default: m.ComparacionPlanesSection
})));
const LifestyleSection = lazy(() => import('../components/LifestyleSection').then(m => ({
  default: m.LifestyleSection
})));
const EmotionalCloseSection = lazy(() => import('../components/EmotionalCloseSection').then(m => ({
  default: m.EmotionalCloseSection
})));
const IdentitySection = lazy(() => import('../components/IdentitySection').then(m => ({
  default: m.IdentitySection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SalesNotification = lazy(() => import('../components/SalesNotification').then(m => ({
  default: m.SalesNotification
})));
export function LandingPage() {
  useEffect(() => {
    // Initialize Meta Pixel — ONLY on the landing/sales page
    const w = window as any;
    if (!w.fbq) {
      const n = w.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      w.fbq('init', '919180517627113');
      w.fbq('track', 'PageView');
    }
    // === BLOCKER: Intercept and DROP banned custom events ===
    // This catches events from ANY source (external scripts, tag managers, etc.)
    const BANNED_EVENTS = new Set(['scroll_depth', 'cta_click', 'upsell_view', 'upsell_accept', 'upsell_reject', 'UpsellAccepted']);
    if (w.fbq && !w.__fbqBlocked) {
      const originalFbq = w.fbq;
      w.fbq = function (...args: any[]) {
        const method = args[0]; // 'track', 'trackCustom', etc.
        const eventName = args[1];
        // Block banned events from both 'track' and 'trackCustom'
        if ((method === 'track' || method === 'trackCustom') && typeof eventName === 'string' && BANNED_EVENTS.has(eventName)) {
          if (import.meta.env?.DEV) {
            console.warn(`[Pixel BLOCKED] ${method}('${eventName}') — dropped`);
          }
          return; // silently drop
        }
        return originalFbq.apply(this, args);
      };
      // Preserve all properties from original fbq
      Object.keys(originalFbq).forEach(key => {
        if (!(key in w.fbq)) {
          w.fbq[key] = originalFbq[key];
        }
      });
      w.fbq.queue = originalFbq.queue;
      w.fbq.push = w.fbq;
      w.__fbqBlocked = true; // prevent double-wrapping
    }
    // === END BLOCKER ===
    // Load fbevents.js — deferred to not block FCP/LCP
    const loadPixelScript = () => {
      if (document.querySelector('script[src*="fbevents.js"]')) return;
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=919180517627113&ev=PageView&noscript=1';
      document.body.appendChild(img);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixelScript, {
        timeout: 1500
      });
    } else {
      setTimeout(loadPixelScript, 800);
    }
    // Fire ViewContent once on landing page load
    import('../lib/tracking').then(m => m.trackViewContent());
  }, []);
  return <div className="min-h-screen bg-dark font-sans text-white selection:bg-gold/30 selection:text-gold overflow-x-hidden w-full relative" data-id="element-817">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[99999] focus:bg-gold focus:text-dark focus:px-4 focus:py-2 focus:rounded focus:font-bold" data-id="element-818">
        Saltar al contenido principal
      </a>

      <Navbar data-id="element-819" />

      <main id="main-content" className="overflow-x-hidden" data-id="element-820">
        <HeroSection data-id="element-821" />

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-823" />} data-id="element-822">
          <ClaridadSection data-id="element-824" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-826" />} data-id="element-825">
          <QueEsSection data-id="element-827" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-829" />} data-id="element-828">
          <MetodoSection data-id="element-830" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-832" />} data-id="element-831">
          <MecanismoNuevoSection data-id="element-833" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-835" />} data-id="element-834">
          <TestimoniosSection data-id="element-836" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-838" />} data-id="element-837">
          <QueIncluyeSection data-id="element-839" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-841" />} data-id="element-840">
          <NoEsParaTiSection data-id="element-842" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-844" />} data-id="element-843">
          <ComparacionPlanesSection data-id="element-845" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-847" />} data-id="element-846">
          <LifestyleSection data-id="element-848" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-850" />} data-id="element-849">
          <EmotionalCloseSection data-id="element-851" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-853" />} data-id="element-852">
          <IdentitySection data-id="element-854" />
        </Suspense>

        {/* BOTÓN FLOTANTE MOBILE */}
        <div className="fixed bottom-4 left-0 right-0 z-[9999] flex justify-center px-4 sm:hidden pointer-events-none" data-id="element-855">
          <button type="button" onClick={() => {
          document.getElementById('comparacion')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }} className="pointer-events-auto w-full max-w-md" aria-label="Ir a la sección de planes" data-id="element-856">
            <div className="relative overflow-hidden rounded-2xl border border-gold/30 bg-black/85 backdrop-blur-xl shadow-[0_10px_40px_rgba(212,175,55,0.25)]" data-id="element-857">
              <div className="absolute inset-0 bg-gradient-to-r from-gold/10 via-gold/5 to-gold/10 animate-pulse" data-id="element-858" />

              <div className="relative flex items-center justify-between px-5 py-4" data-id="element-859">
                <div className="flex flex-col text-left" data-id="element-860">
                  <span className="text-[11px] uppercase tracking-[0.2em] text-gold/70 font-semibold" data-id="element-861">
                    Código 888
                  </span>

                  <span className="text-white font-bold text-sm leading-tight" data-id="element-862">
                    Comenzar Experiencia
                  </span>
                </div>

                <span className="text-gold font-black text-xl" data-id="element-863">→</span>
              </div>
            </div>
          </button>
        </div>
      </main>

      <Suspense fallback={null} data-id="element-864">
        <Footer data-id="element-865" />
        <SalesNotification data-id="element-866" />
      </Suspense>

      <BackgroundAudio data-id="element-867" />
    </div>;
}